export const getImageUrl = (image: string) => {
	return `https://assets.breakmark.com/pub/upload/${image}`;
};
